import type { Skill } from '../types';

import { applyBrandKitSkill } from './applyBrandKit';
import { createAnimatedVideoSkill } from './createAnimatedVideo';
import { createBoldCaptionsVideoSkill } from './createBoldCaptionsVideo';
import { createBrandStoryVideoSkill } from './createBrandStoryVideo';
import { createListAndStepsVideoSkill } from './createListAndStepsVideo';
import { createMediaMontageVideoSkill } from './createMediaMontageVideo';
import { createMotionGraphicsVideoSkill } from './createMotionGraphicsVideo';
import { createPodcastWaveformVideoSkill } from './createPodcastWaveformVideo';
import { createPromoAdSkill } from './createPromoAd';
import { createQuotesShowcaseVideoSkill } from './createQuotesShowcaseVideo';
import { createReportSummaryVideoSkill } from './createReportSummaryVideo';
import { createSimilarToVideoSkill } from './createSimilarToVideo';
import { createSlideNarrationVideoSkill } from './createSlideNarrationVideo';
import { createTalkingHeadExplainerVideoSkill } from './createTalkingHeadExplainerVideo';
import { createVideoSkill } from './createVideo';
import { aiVoiceoverVideoBasicsSkill } from './aiVoiceoverVideoBasics';
import { changeTemplateSkill } from './changeTemplate';
import { cropMediaSkill } from './cropMedia';
import { documentBasicsSkill } from './documentBasics';
import { editVideoDuration } from './editVideoDuration';
import { findDamMediaSkill } from './findDamMedia';
import { findStockMediaSkill } from './findStockMedia';
import { findUserMediaSkill } from './findUserMedia';
import { gatherRequirementsSkill } from './gatherRequirements';
import { htmlCompositionSkill } from './htmlComposition';
import { thirdPartyVideoLinkSkill } from './thirdPartyVideoLink';
import { fixTextContrastSkill } from './fixTextContrast';
import { fixTextWrappingSkill } from './fixTextWrapping';
import { motionGraphicsScenesBasicsSkill } from './motionGraphicsScenesBasics';
import { recordedVoiceoverVideoBasicsSkill } from './recordedVoiceoverVideoBasics';
import { reviewVideoSkill } from './reviewVideo';
import { talkingHeadVideoBasicsSkill } from './talkingHeadVideoBasics';
import { textVideoBasicsSkill } from './textVideoBasics';
import { voiceoverVideoBasicsSkill } from './voiceoverVideoBasics';
import { writeTextVideoScriptSkill } from './writeTextVideoScript';
import { writeVoicedrivenVideoScriptSkill } from './writeVoicedrivenVideoScript';

// Re-exported so callers that need individual skills (the skill-routing eval's
// key map) can pull them from one module instead of 24 deep imports.
export * from './applyBrandKit';
export * from './createAnimatedVideo';
export * from './createBoldCaptionsVideo';
export * from './createBrandStoryVideo';
export * from './createListAndStepsVideo';
export * from './createMediaMontageVideo';
export * from './createMotionGraphicsVideo';
export * from './createPodcastWaveformVideo';
export * from './createPromoAd';
export * from './createQuotesShowcaseVideo';
export * from './createReportSummaryVideo';
export * from './createSimilarToVideo';
export * from './createSlideNarrationVideo';
export * from './createTalkingHeadExplainerVideo';
export * from './createVideo';
export * from './aiVoiceoverVideoBasics';
export * from './changeTemplate';
export * from './cropMedia';
export * from './documentBasics';
export * from './editVideoDuration';
export * from './findDamMedia';
export * from './findStockMedia';
export * from './findUserMedia';
export * from './fixTextContrast';
export * from './fixTextWrapping';
export * from './gatherRequirements';
export * from './htmlComposition';
export * from './motionGraphicsScenesBasics';
export * from './thirdPartyVideoLink';
export * from './recordedVoiceoverVideoBasics';
export * from './reviewVideo';
export * from './talkingHeadVideoBasics';
export * from './textVideoBasics';
export * from './voiceoverVideoBasics';
export * from './writeTextVideoScript';
export * from './writeVoicedrivenVideoScript';

export const DEFAULT_SKILLS: Skill[] = [
    createVideoSkill,
    createAnimatedVideoSkill,
    createSimilarToVideoSkill,
    // Dashboard tile order follows this list, so the recipes below sit in the
    // order they should be offered in — with the audiogram, narrated slides and
    // bold captions last. `createVideo` carries a tile too and is registered
    // above, so it takes the first slot.
    createListAndStepsVideoSkill,
    createPromoAdSkill,
    createBrandStoryVideoSkill,
    createMotionGraphicsVideoSkill,
    createMediaMontageVideoSkill,
    createQuotesShowcaseVideoSkill,
    createReportSummaryVideoSkill,
    createTalkingHeadExplainerVideoSkill,
    createPodcastWaveformVideoSkill,
    createSlideNarrationVideoSkill,
    createBoldCaptionsVideoSkill,
    changeTemplateSkill,
    gatherRequirementsSkill,
    findStockMediaSkill,
    findUserMediaSkill,
    findDamMediaSkill,
    voiceoverVideoBasicsSkill,
    aiVoiceoverVideoBasicsSkill,
    recordedVoiceoverVideoBasicsSkill,
    textVideoBasicsSkill,
    talkingHeadVideoBasicsSkill,
    writeTextVideoScriptSkill,
    writeVoicedrivenVideoScriptSkill,
    documentBasicsSkill,
    thirdPartyVideoLinkSkill,
    motionGraphicsScenesBasicsSkill,
    htmlCompositionSkill,
    cropMediaSkill,
    editVideoDuration,
    fixTextWrappingSkill,
    fixTextContrastSkill,
    reviewVideoSkill,
    applyBrandKitSkill,
];
